module.exports = __webpack_public_path__ + "img/weather29.1d85aab4.png";